module.exports = __webpack_public_path__ + "img/0.b15d71ac.jpg";